import Vue from 'vue';
import App from './App.vue';
import router, { updateDocumentTitle } from './router';
import i18n from './i18n';
import lazyLoad from './directives/lazyLoad';

import '@/styles/base.scss';

Vue.config.productionTip = false;
Vue.directive('lazy', lazyLoad);

const app = new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

app.$watch(
  () => app.$i18n.locale,
  () => {
    updateDocumentTitle(router.currentRoute);
  },
  { immediate: true },
);
